import React from 'react'

const Footer = () => {
    return (
      <footer className="crm-footer">
        Copyright © {process.env.REACT_APP_ORGANIZER_NAME || "BOJ SHOW"}. All Rights Reserved.
      </footer>
    );
}

export default Footer